export default {
    childrenIds: [],
    nursery_search_id: null
}
